<template>
    <div class="modal-open-file" v-show="showModal">
        <div class="my-modal">
            <div class="wrapper">
                <div class="title">
                    Abrir Archivo
                </div>
                <div class="body">
                    <div><p>Abrir un archivo local:</p></div>
                    <input type="file" ref="files" id="files" name="files[]" v-bind:accept="acceptFormat" v-on:change="fileSelected"/>
                </div>
                <div class="footer">
                    <PsButton :model="'Cancelar'" :icon="'fa-times'" :icon-color="'fa-red'" @click="showModal = false"></PsButton>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { EventBus } from './../EventBus.js'
    import PsButton from './Widget/PsButton'

    export default {
        name: 'ModalOpenFile',
        components: {
            PsButton
        },
        created () {
            this.registerEventHandlers()
        },
        methods: {
            registerEventHandlers () {
                EventBus.$on('editor.open.dialog', (data) => {
                    this.triggerEvent = 'editor'
                    this.showModal = true
                    this.acceptFormat = '.psf'
                })
                EventBus.$on('config.open.dialog', (data) => {
                    this.triggerEvent = 'config'
                    this.showModal = true
                    this.acceptFormat = '.json'
                })
            },
            fileSelected (evt) {
                let file = evt.target.files[0]
                let reader = new FileReader()
                let that = this
                reader.onload = (function (theFile) {
                    return function (e) {
                        EventBus.$emit(that.triggerEvent + '.open', {
                            data: e.target.result
                        })
                        that.showModal = false
                        that.$refs.files.value = null
                    }
                })(file)

                reader.readAsText(file)
            }
        },
        data () {
            return {
                showModal: false,
                triggerEvent: '',
                acceptFormat: ''
            }
        }
    }
</script>

<style>
    
    .my-modal {
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        background: rgba(0.5,0.5,0.5, 0.4);
        z-index: 1000;
        text-align: center;
    }

    .my-modal .wrapper {
        display: inline-block;
        border: 1px solid #555;
        box-shadow: 0px 0px 12px rgba(0.5, 0.5, 0.5, 0.3);
        padding: 0px;
        margin-top: 100px;
        background: #FFF;
        text-align: left;
        max-width: 800px;
        min-width: 500px;

    }
    .my-modal .title {
        margin-bottom: 10px;
        padding-left: 4px;
        padding-right: 4px;
        padding-bottom: 6px;
        padding-top: 2px;
        background-color: #D0D9E9;
        font-size: 12px;
        height: 15px;
        overflow: hidden;
        border-bottom: 1px solid #A0A9C9;
    }
    .my-modal .body {
        margin-bottom: 10px;
        padding-left: 10px;
        padding-right: 10px;
    }
    .my-modal .footer {
        text-align: right;
        margin-bottom: 10px;
        padding-left: 10px;
        padding-right: 10px;
    }
    .my-modal textarea {
        width: 100%;
        border: 1px solid #AAA;
        margin-top: 6px;
        padding: 0px;
    }


</style>


// WEBPACK FOOTER //
// src/Components/ModalOpenFile.vue